import Vue from 'vue';

export default {
  SET_ACTIVE_CUSTOMER_ID: (state, { compId, payload }) => {
    Vue.set(state.activeCustomersIds, compId, payload);
  },
};


// WEBPACK FOOTER //
// ./src/store/customers/mutations.js